export default __webpack_public_path__ + "static/techno-f1ac860ee898d6e11619d560836dc264.png";